import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import './App.scss';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import { IContent } from './types';

import CONFIG from './config';
import {
  fetchEnd,
  fetchProducts,
  fetchStart,
  setInitialized
} from './features/appSlice';
import { poll } from './utils';

import HighlightsSection from './components/Sections/Highlights/HighlightsSection';
import EditionsSection from './components/Sections/Editions/EditionsSection';

interface IAppProps {
  localeId: string;
  setInitialized?: any;
  fetchStart?: any;
  fetchEnd?: any;
  fetchProducts?: any;
}

const App = (props: IAppProps) => {
  const { localeId } = props;
  const localizedContent: any = data.filter(
    (locale) => locale.lang === localeId
  )[0];

  if (localizedContent) {
    const { products } = localizedContent;
    const productsToFetch = CONFIG.isUPC ? products.upc : products.web;
    props.fetchStart(productsToFetch);
  }

  useEffect(() => {
    const initializeApp = async () => {
      // @ts-ignore
      window.baseSitePath = CONFIG.isUPC ? '/upc' : '';
      const windowInitialized = await poll(
        () => {
          return (
            (window as any).GeoRestrictedResources &&
            (window as any).Constants &&
            (window as any).Urls
          );
        },
        2000,
        150
      );
      if (windowInitialized) {
        props.setInitialized(true);
        if (localizedContent) {
          const { products } = localizedContent;
          const productsToFetch = CONFIG.isUPC ? products.upc : products.web;
          const currency =
            window.GeoRestrictedResources.STOREFRONT_CURRENCY_CODE;
          const locale =
            window.GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE.replace(
              '_',
              '-'
            );
          props
            .fetchProducts(productsToFetch, currency, locale)
            .then(() => {
              props.fetchEnd(productsToFetch);
            })
            .catch(() => {
              props.fetchEnd(productsToFetch);
            });
        }
      }
    };
    initializeApp();
  }, []);

  return (
    <main id="r6e_game_page" className={localizedContent.config.country_code}>
      <ContentProvider value={localizedContent}>
        <HighlightsSection />
        <EditionsSection />
      </ContentProvider>
    </main>
  );
};

const mapStateToProps = (state: any) => ({
  initialized: state.app.initialized
});

const mapDispatchToProps = {
  setInitialized,
  fetchStart,
  fetchEnd,
  fetchProducts
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
